<template>
    <div>
        <h2 class="text-center">DANH SÁCH KHÁCH HÀNG</h2>
        <table class="mx-auto table-border">
            <thead>
                <tr>
                    <th class="text-center text-no-wrap">Phòng</th>
                    <th class="text-center text-no-wrap">Họ và tên</th>
                    <th class="text-center">SDT</th>
                    <th class="text-center">Số xe</th>
                    <th class="text-center">Xe đạp</th>
                    <th class="text-center">Máy giặt</th>
                    <th class="text-center">Ngày dọn vào</th>
                </tr>
            </thead>
            <tbody>
                <tr
                    v-for="item in items"
                    :key="item._id"
                >
                    <td class="text-center">{{ item.show_room_id ? item.room_id : "" }}</td>
                    <td class="text-left text-no-wrap">{{ item.name }}</td>
                    <td class="text-center">{{ item.phone }}</td>
                    <td class="text-left text-no-wrap">{{ item.motorbike }}</td>
                    <td class="text-center">{{ item.bike ?  'Có' : '' }}</td>
                    <td class="text-center">{{ item.is_wm ?  'Có' : '' }}</td>
                    <td class="text-center text-no-wrap">{{ item.date_in | formatTimeServer}}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    name: "print-bang-khach-hang",
    props: {
        items: {
            type: Array,
            default: [],
        },
    },
    data(){
        return {}
    }
};
</script>

<style>
</style>